import { useEffect, type ReactNode } from 'react';
import { AlertTriangle } from 'lucide-react';
import { AppLayout } from '@/components/layout/app-layout';
import { Skeleton } from '@/components/ui/skeleton';
import { Button } from '@/components/ui/button';
import { useImportacion } from '../store/importacion-store';

/**
 * El marco de las pantallas de Comercia: el ancho de la maqueta, y la importación
 * cargada antes de dibujar (cada pantalla la lee del mismo lugar).
 */
export function MarcoDeComercia({ children }: { children: ReactNode }) {
  const { cargando, error, cargar } = useImportacion();

  useEffect(() => {
    // Al entrar a cualquier paso se relee: otra pestaña pudo haber cambiado algo.
    void cargar();
  }, [cargar]);

  return (
    <AppLayout>
      <div className="mx-auto max-w-[1500px] space-y-6 px-4 py-8 md:px-8">
        {error ? (
          <div
            role="alert"
            className="flex flex-wrap items-center gap-3 rounded-tarjeta border border-bloqueo-borde bg-bloqueo-suave px-5 py-4 text-sm text-bloqueo"
          >
            <AlertTriangle className="h-4 w-4 shrink-0" aria-hidden="true" />
            <span className="flex-1">{error}</span>
            <Button size="sm" variant="outline" onClick={() => void cargar()}>
              Reintentar
            </Button>
          </div>
        ) : cargando ? (
          <div className="space-y-6" aria-busy="true" aria-label="Cargando tu importación">
            <Skeleton className="h-28 w-full rounded-tarjeta" />
            <Skeleton className="h-16 w-full rounded-tarjeta" />
            <Skeleton className="h-80 w-full rounded-tarjeta" />
          </div>
        ) : (
          children
        )}
      </div>
    </AppLayout>
  );
}
